import { render, staticRenderFns } from "./IndividualReportDocumentsPanel.vue?vue&type=template&id=163e7431"
import script from "./IndividualReportDocumentsPanel.vue?vue&type=script&lang=ts"
export * from "./IndividualReportDocumentsPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports